import CoreIndex from 'core/js/pages/municipality-data/travels/index'
import Travel from './_travel'

export default CoreIndex.extend({
  components: { Travel }
})
